import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { BehaviorSubject } from 'rxjs';

import { LocalStorageService, StorageKey } from '@blaze-shared/platform-data-access';
import {
  ButtonBarComponent,
  ButtonIconComponent,
  DialogComponent,
  JsonNode,
  ScrollerComponent,
  TreeSelectComponent,
} from '@blaze-shared/shared-ui';

import { ApiBuilderStore } from '../+state/api-builder.store';
import { ApiBuilderAction } from '../api-builder.model';

export interface ResultPathSelectDialogData {
  action: ApiBuilderAction;
}

@Component({
  selector: 'blaze-result-path-select-page',
  imports: [
    AsyncPipe,
    ButtonBarComponent,
    ButtonIconComponent,
    DialogComponent,
    MatIconModule,
    ScrollerComponent,
    TreeSelectComponent,
  ],
  templateUrl: './result-path-select-dialog.component.html',
  styleUrls: ['./result-path-select-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResultPathSelectDialogComponent implements OnInit {
  private readonly apiBuilderStore = inject(ApiBuilderStore);
  private readonly dialogData = inject<ResultPathSelectDialogData>(MAT_DIALOG_DATA);
  private readonly dialogRef = inject<MatDialogRef<ResultPathSelectDialogComponent>>(MatDialogRef);
  private readonly localStorageService = inject(LocalStorageService);

  data$ = new BehaviorSubject<any>(undefined);
  action = this.dialogData.action;
  resultPath$ = new BehaviorSubject<string>('');
  saving$ = this.apiBuilderStore.savingConnector$;
  accountId = this.localStorageService.get(StorageKey.AccountId) || '';
  selectedNode: JsonNode | null = null;

  ngOnInit(): void {
    this.data$.next(this.action.response);
    this.resultPath$.next(this.action.resultPath);
  }

  save(): void {
    this.apiBuilderStore.setResultPath({
      accountId: this.accountId,
      actionId: this.action.id,
      resultPath: this.selectedNode?.path ?? '',
      successCallback: () => this.returnToBuilder(),
    });
  }

  nodeSelected(node: JsonNode): void {
    this.selectedNode = node;
  }

  returnToBuilder(): void {
    this.dialogRef.close();
  }
}
